module.exports = __webpack_public_path__ + "static/img/role.fd3d4d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/sy/role.png
// module id = UZR1
// module chunks = 7